import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Select, MenuItem, TextField, Switch, FormControlLabel } from '@mui/material';

const OPERATORS = [
  { value: 'equals', label: 'equals' },
  { value: 'not_equals', label: 'not equals' },
  { value: 'contains', label: 'contains' },
  { value: 'exists', label: 'exists' },
];

export default function EdgeProperties({ edge, onUpdateEdge }) {
  const data = edge.data || {};
  const [conditional, setConditional] = useState(!!data.condition);
  const [field, setField] = useState(data.condition?.field || '');
  const [operator, setOperator] = useState(data.condition?.operator || 'equals');
  const [value, setValue] = useState(data.condition?.value || '');
  const [behavior, setBehavior] = useState(data.behavior || 'append');
  const [exclusive, setExclusive] = useState(data.exclusive || false);

  const mountedRef = useRef(false);
  useEffect(() => {
    if (!mountedRef.current) { mountedRef.current = true; return; }
    const condition = conditional && field ? { field, operator, value } : undefined;
    onUpdateEdge(edge.id, { condition, behavior, exclusive: conditional ? exclusive : false });
  }, [conditional, field, operator, value, behavior, exclusive, onUpdateEdge, edge.id]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Typography variant="overline" sx={{ fontSize: 9 }}>Edge Properties</Typography>

      <Box>
        <Typography variant="overline" sx={{ fontSize: 9 }}>Behavior</Typography>
        <Select size="small" fullWidth value={behavior} onChange={(e) => setBehavior(e.target.value)} sx={{ fontSize: 11, mt: 0.5 }}>
          <MenuItem value="append" sx={{ fontSize: 11 }}>Append</MenuItem>
          <MenuItem value="replace" sx={{ fontSize: 11 }}>Replace</MenuItem>
        </Select>
      </Box>

      <FormControlLabel
        control={<Switch size="small" checked={conditional} onChange={(e) => setConditional(e.target.checked)} />}
        label={<Typography sx={{ fontSize: 11 }}>Conditional</Typography>}
      />

      {conditional && (
        <>
          <FormControlLabel
            control={<Switch size="small" checked={exclusive} onChange={(e) => setExclusive(e.target.checked)} />}
            label={<Typography sx={{ fontSize: 11 }}>Exclusive — stop on first match</Typography>}
          />
          <TextField
            label="Field (e.g. ticket.vendor_id)"
            size="small"
            value={field}
            onChange={(e) => setField(e.target.value)}
            inputProps={{ style: { fontSize: 11 } }}
          />
          <Select size="small" value={operator} onChange={(e) => setOperator(e.target.value)} sx={{ fontSize: 11 }}>
            {OPERATORS.map((op) => (
              <MenuItem key={op.value} value={op.value} sx={{ fontSize: 11 }}>{op.label}</MenuItem>
            ))}
          </Select>
          {operator !== 'exists' && (
            <TextField
              label="Value"
              size="small"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              inputProps={{ style: { fontSize: 11 } }}
            />
          )}
        </>
      )}
    </Box>
  );
}
